module.exports = __webpack_public_path__ + "img/sierraint2.eb2e36b4.png";